import React from "react";

import { AU, GB, NL, PH, US } from "country-flag-icons/react/3x2";

const FlagIcon = ({ countryCode }: { countryCode: string }) => {
  const style = {
    width: "30px",
    height: "20px",
  };

  switch (countryCode) {
    case "au":
      return <AU title="Australia" style={style} data-testid="au-flag" />;
    case "gb":
      return <GB title="United Kingdom" style={style} data-testid="gb-flag" />;
    case "nl":
      return <NL title="Netherlands" style={style} data-testid="nl-flag" />;
    case "ph":
      return <PH title="Philippines" style={style} data-testid="ph-flag" />;
    case "us":
      return <US title="United States" style={style} data-testid="us-flag" />;
    default:
      return <AU title="Australia" style={style} data-testid="au-flag" />;
  }
};

export default FlagIcon;
